import React, {useEffect} from "react";

import './AlarmExpandableContent.scss'
import {CodeSnippet, Column, Grid} from "@carbon/react";
import AlarmEventsTable from "../AlarmEventsTable";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import {useRecoilValue} from "recoil";
import {grpcAlarmServiceSelector} from "../../../state/grpc";
import {Link} from "react-router-dom";

const AlarmExpandableContent = (props) => {
  const alarm = props.alarm
  const readme = alarm.readme.length > 0 ? alarm.readme : "Non sono presenti indicazioni per questo allarme."
  const notes = alarm.notes.length > 0 ? alarm.notes : "Non è stata inserita alcuna nota."
  const alarmsService = useRecoilValue(grpcAlarmServiceSelector)

  useEffect(() => {
    if (alarm.status === "Aperto" && !alarm.read) {
      const req = new proto.api.MarkAsReadRequest()
      req.setAlarmidsList([alarm.id])
      req.setRead(true)
      alarmsService.markAsRead(req, null, (err, resp) => {
        if (err != null) {
          console.error(err)
        } else {
          props.onContentExpanded()
        }
      })
    }
  }, [])

  return (
    <Grid fullWidth className="alerts-row-expandable" key={alarm.id}>
      <Column lg={16} md={8} sm={4}>
        <Grid className="alerts-row-expandable__row">
          <Column lg={16} md={8} sm={4}>
            <h6>Indicazioni</h6>
            <span>{readme}</span>
          </Column>
        </Grid>
      </Column>
      <Column lg={16} md={8} sm={4}>
        <Grid className="alerts-row-expandable__row">
          <Column lg={16} md={8} sm={4}>
            <h6>Note aggiuntive</h6>
            <span>{notes}</span>
          </Column>
        </Grid>
      </Column>
      <Column lg={16} md={8} sm={4}>
        <Grid className="alerts-row-expandable__row">
          <Column lg={16} md={8} sm={4}>
            <h6>Link condivisione</h6>
            <CodeSnippet feedback="Testo copiato"><Link
              to={`/alarms/` + alarm.id}>{location.protocol + '//' + location.host + `/#/alarms/` + alarm.id}</Link></CodeSnippet>
          </Column>
        </Grid>
      </Column>
      <Column lg={16} md={8} sm={4}>
        <Grid className="alerts-row-expandable__statusbar">
          <Column lg={16} md={8} sm={4}>
            <h6>Eventi</h6>
            <AlarmEventsTable alarmId={alarm.id}/>
          </Column>
        </Grid>
      </Column>
      <Column lg={16} md={8} sm={4}>
        <Grid className="alerts-row-expandable__row">
          <Column lg={16} md={8} sm={4}>
            <h6>Oggetto mail</h6>
            <span>{alarm.shortDesc}</span>
          </Column>
        </Grid>
      </Column>
      <Column lg={16} md={8} sm={4}>
        <Grid className="alerts-row-expandable__row">
          <Column lg={16} md={8} sm={4}>
            <h6>Contenuto mail</h6>
            <CodeSnippet type="multi" feedback="Testo copiato" className="alerts-row-expandable__code_snippet"
                         showMoreText="Mostra di più" showLessText="Mostra di meno"
                         minCollapsedNumberOfRows={3} maxCollapsedNumberOfRows={5} wrapText={true}>
              {
                parse(
                  alarm.longDesc.replace(/\n/g, ""),
                  {
                    trim: true,
                    replace: (domNode) => {
                      if (domNode.constructor.name === "Element" && domNode.name === "style") {
                        return <></>
                      }
                    },
                  }
                )}
            </CodeSnippet>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

AlarmExpandableContent.propType = {
  alarm: PropTypes.object.isRequired,
  onContentExpanded: PropTypes.func.isRequired,
}

export default AlarmExpandableContent